// extracted by mini-css-extract-plugin
export default {"card":"BaseCard_card__wQWSl","card__content":"BaseCard_card__content__2j-qO"};